import React from 'react';
import {Typography} from 'src/styles';
import {Text, View} from 'react-native';
import {useStyle} from 'src/providers/style';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import InformationTooltip from 'src/modules/programs/components/information-tooltip';
import {Separator} from 'src/common-components/atoms';

const ClientStaffRetention = ({active = 0, title = 'Clients'}: any) => {
  const styles = useStyle();
  const tooltipText =
    title === 'Clients'
      ? 'Counts clients who had a completed session in the last 30 days, excluding any that are archived or deleted.'
      : 'Includes all staff members who have not been archived or deleted.';

  return (
    <View
      style={[styles.width, styles.padding, styles.row, styles.alignCenter]}>
      <Icon
        name={title === 'Clients' ? 'account-circle' : 'account-supervisor'}
        size={36}
      />
      <View style={[styles.marginLLeft, styles.marginTop]}>
        <Text style={[Typography.H4]}>{active}</Text>
        <Text style={[Typography.P3, styles.textColorPrimary]}>
          Active {title}
          <Separator width={4} />
          <InformationTooltip value={tooltipText} />
        </Text>
      </View>
    </View>
  );
};

export default ClientStaffRetention;
